import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba3bcccc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.sass?vue&type=style&index=0&id=ba3bcccc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3bcccc",
  null
  
)

export default component.exports